const ThankYou = () => {
	return (
		<>
			<div className="thankyou">
				<h2>Thank You </h2>
				<p>Your application has been successfully submitted.</p>
			</div>
		</>
	);
};

export default ThankYou;
